import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client for the backoffice SPA.
 *
 * Defaults:
 *  - staleTime 30s  — avoid thundering-herd refetches on tab focus switches
 *  - retry 1        — transient failures retried once; hard errors surface fast
 *  - refetchOnWindowFocus false — backoffice data is driven by explicit invalidation
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
